import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DashboardService from "services/DashboardService";

export const getDashboardCount = createAsyncThunk(
  "school/getDashboardCount",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getDashboardCount(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSchoolDashboard = createAsyncThunk(
  "school/getSchoolDashboard",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getSchoolDashboard(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch school dashboard"
      );
    }
  }
);
export const getOrderDashboard = createAsyncThunk(
  "school/getOrderDashboard",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getOrderDashboard(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch order dashboard"
      );
    }
  }
);
export const getCompletedOrderDashboard = createAsyncThunk(
  "school/getCompletedOrderDashboard",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getCompletedOrderDashboard(
        params
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
        "Failed to fetch completed order dashboard"
      );
    }
  }
);
export const getPendingOrderDashboard = createAsyncThunk(
  "school/getPendingOrderDashboard",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getPendingOrderDashboard(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch pending order dashboard"
      );
    }
  }
);
export const getCancelledOrderDashboard = createAsyncThunk(
  "school/getCancelledOrderDashboard",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getCancelledOrderDashboard(
        params
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
        "Failed to fetch cancelled order dashboard"
      );
    }
  }
);
export const getStudentDashboard = createAsyncThunk(
  "school/getStudentDashboard",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getStudentDashboard(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch student dashboard"
      );
    }
  }
);
export const getRevenueDashboard = createAsyncThunk(
  "school/getRevenueDashboard",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getRevenueDashboard(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch revenue dashboard"
      );
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboardItems: {},
    singledashboard: {},
    schoolDashboard: {},
    orderDashboard: {},
    completedOrderDashboard: {},
    pendingOrderDashboard: {},
    cancelledOrderDashboard: {},
    studentDashboard: {},
    revenueDashboard: {},
    studentSelectedAcademicYear: null,
    loading: false,
    error: null,
    selectedSchool: null,
  },
  reducers: {
    setSelectedSchool: (state, action) => {
      state.selectedSchool = action.payload;
    },
    setStudentSelectedAcademicYear: (state, action) => {
      state.studentSelectedAcademicYear = action.payload;
    },
    clearSelectedSchool: (state) => {
      state.selectedSchool = null;
      console.log("Clearing selected school", state.selectedSchool);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardCount.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardItems = action.payload;
      })
      .addCase(getDashboardCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSchoolDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSchoolDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.schoolDashboard = action.payload;
      })
      .addCase(getSchoolDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getOrderDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrderDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.orderDashboard = action.payload;
      })

      .addCase(getOrderDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCompletedOrderDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompletedOrderDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.completedOrderDashboard = action.payload;
      })
      .addCase(getCompletedOrderDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPendingOrderDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPendingOrderDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingOrderDashboard = action.payload;
      })
      .addCase(getPendingOrderDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCancelledOrderDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCancelledOrderDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.cancelledOrderDashboard = action.payload;
      })
      .addCase(getCancelledOrderDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getStudentDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStudentDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.studentDashboard = action.payload;
      })
      .addCase(getStudentDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getRevenueDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.revenueDashboard = {};
      })
      .addCase(getRevenueDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.revenueDashboard = action.payload;
      })
      .addCase(getRevenueDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedSchool, clearSelectedSchool, setStudentSelectedAcademicYear } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
